import React, { ReactElement, ReactNode, useState, useMemo, useEffect } from 'react';
import { usePopper } from 'react-popper';

// Hooks
import useElementDimensions from '../../../../../hooks/useElementDimensions';

// Styles
import './EmojiMartDropdownPopover.scss';

interface PopoverProps {
  children: ReactNode;
  popperOptions?;
  emojiMartDropdownRef: React.Ref<HTMLDivElement>;
}

export default function EmojiMartDropdownPopover({
  children,
  popperOptions = { placement: 'bottom-start' },
  emojiMartDropdownRef,
}: PopoverProps): ReactElement {
  const dimensions = useElementDimensions({ elementRef: emojiMartDropdownRef });

  const [className, setClassName] = useState('EmojiMartDropdownPopover');
  const [popperElement, setPopperElement] = useState<HTMLElement | null>(null);

  // virtual elements need to useMemo to prevent infinite loop
  // https://github.com/floating-ui/react-popper/issues/391
  const virtualElement = useMemo(
    () => ({
      getBoundingClientRect: () => {
        return {
          top: dimensions?.top,
          left: dimensions?.left,
          bottom: dimensions?.bottom,
          right: dimensions?.right,
          width: dimensions?.width,
          height: dimensions?.height,
        };
      },
    }),
    [dimensions]
  );

  // @ts-ignore
  const { styles, attributes } = usePopper(virtualElement, popperElement, popperOptions);

  useEffect(() => {
    requestAnimationFrame(() => setClassName('EmojiMartDropdownPopover EmojiMartDropdownPopover--visible'));
  }, []);

  return (
    <div ref={setPopperElement} style={styles.popper} {...attributes.popper} className={className}>
      {children}
    </div>
  );
}
